import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicySection from "./sections/PrivacyPolicy";
import Footer from "@/reusable_sections/Footer";
import { CosmicBackground } from "@/components/cosmic/CosmicBackground";
export default function PrivacyPolicyPage() {
  return <div className="relative min-h-screen min-h-[100svh] w-full max-w-full bg-background text-foreground overflow-x-clip">
      {/* Root fixed cosmic starfield with calm density and blue accent */}
      <CosmicBackground fixed accent="blue" density={0.7} />
      <div className="relative z-10 flex min-h-screen min-h-[100svh] w-full max-w-full flex-col">
        <Header />
        <main className="flex-1 w-full max-w-full">
          <PrivacyPolicySection />
        </main>
        <Footer />
      </div>
    </div>;
}